import React, { ReactElement, useCallback } from 'react';

import {
   MedicalInformationAttachment,
   MedicalInformationAttachmentUnmarkAsRemovedCommand,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Link, RemoveIcon, RotateRightIcon } from '@dreryk/react-components';
import { useBoolean } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { refetchAllMedicalInformation } from '../shared/refetchAllMedicalInformation';

import { MedicalInformationAttachmentMarkAsRemovedModal } from './MedicalInformationAttachmentMarkAsRemovedModal';

type MedicalInformationAttachmentRemoveOrRestoreIconProps = {
   attachment: MedicalInformationAttachment;
};

export const MedicalInformationAttachmentMarkOrUnmarkAsRemovedIcon = (
   props: MedicalInformationAttachmentRemoveOrRestoreIconProps
): ReactElement | null => {
   const { executeAsync: medicalInformationAttachmentUnmarkAsRemoved } = useCqrsCommand<void, void>(
      () => {
         const command = new MedicalInformationAttachmentUnmarkAsRemovedCommand();
         command.attachmentId = props.attachment.id;
         return command;
      },
      {
         onSuccess: () => {
            refetchAllMedicalInformation();
         },
      }
   );
   const handleRestore = useCallback(() => {
      medicalInformationAttachmentUnmarkAsRemoved();
   }, [medicalInformationAttachmentUnmarkAsRemoved]);

   const [{ setTrue: openRemoveModal, setFalse: closeRemoveModal }, removeModalOpened] = useBoolean();

   if (!props.attachment.editable) {
      return null;
   }
   if (props.attachment.removed) {
      return <Link onClick={handleRestore} icon={<RotateRightIcon />} testId={'restore'} />;
   }
   return (
      <>
         <Link onClick={openRemoveModal} icon={<RemoveIcon />} testId={'remove'} />
         {removeModalOpened ? (
            <MedicalInformationAttachmentMarkAsRemovedModal id={props.attachment.id} onClose={closeRemoveModal} />
         ) : null}
      </>
   );
};
